














import { Component, Vue, Prop } from 'vue-property-decorator';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';

@Component
export default class Sender extends Vue {
  @Prop() sender: SigningPageUser;
  @Prop() company: string;

  get title(): string {
    const { title } = this.sender;
    if (title && this.company) {
      return `${title} ${this.$t('role_at')} ${this.company}`;
    }
    if (title) {
      return title;
    }
    if (this.company) {
      return this.company;
    }
    return '';
  }
}
